import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import OptionalDate from "components/optional-date";
import DownloadRoomTemplate from "../utils";
import ReactJson from "react-json-view";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import I18nBoolean from "components/i18n-boolean";
import { TextDisplay } from "components/display-data";
import { LinkWithIcon } from "components/link";
import { Restricted, permissions } from "components/auth";

const RoomTemplateData = ({ roomTemplate, intl, classes }) => {
  return !roomTemplate ? null : (
    <DataGrid>
      <DataGridItem big>
        <div className={classes.subtitle}>{roomTemplate.description}</div>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "roomTemplate.test" })}>
          <I18nBoolean value={roomTemplate.test} />
        </TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <OptionalDate
          className={classes.date}
          label={intl.formatMessage({ id: "common.created" })}
          value={roomTemplate.creationDate}
          icon="event-available"
        />
      </DataGridItem>
      <DataGridItem>
        <DownloadRoomTemplate roomTemplate={roomTemplate} />
      </DataGridItem>
      <Restricted permissions={[permissions.contract_view]}>
        <DataGridItem>
                <LinkWithIcon
                    text={intl.formatMessage({id: "roomTemplate.contract"})}
                    iconName="library-books"
                    color="primary"
                    href={`/contract/details/${roomTemplate.contractId}`}
                />
        </DataGridItem>
      </Restricted>
      <DataGridItem big>
        {roomTemplate.file && (
          <ReactJson
            src={JSON.parse(roomTemplate.file)}
            groupArraysAfterLength={1}
            enableClipboard={false}
            displayObjectSize={false}
            displayDataTypes={false}
            collapseStringsAfterLength={false}
          />
        )}
      </DataGridItem>
    </DataGrid>
  );
};

RoomTemplateData.propTypes = {
  /**
   * Data to represent
   **/
  roomTemplate: PropTypes.object,
};

export default injectIntl(withStyles(styles)(RoomTemplateData));
